import Loading from 'quasar/src/plugins/loading/Loading.js';
import { FileCode, FileFetchKb, PageID } from "src/extensions/utils/DefineTypes";
import { FileHelper } from "src/extensions/utils/FileHelper";
import { defineComponent, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { api } from "~/api";
import { FindFileItemCommand, FindFilesInfoCommand } from "~/api/Common/Commands/FindFilesInfoCommand";
import { GetFilesCommand } from "~/api/Common/Commands/GetFilesCommand";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { MsgBox } from "~/components/MsgBox";
import PdfViewer from "~/components/PdfViewer.vue";
import { Log } from "~/extensions/utils";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { NyukyoStatus, userType } from "~/extensions/utils/DefineTypes";
import { store as taikyoStore } from "~/pages/taikyo/store/TaikyoStore";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
const log = Log.create("KaiyakuSeisanPage");
export default defineComponent({
    name: "KaiyakuSeisanInfoPage",
    components: {
        PdfViewer,
        BreadcrumbList
    },
    // 退去ストア.退去ステータスが精算完了以外の場合は遷移をキャンセル
    async beforeRouteEnter(to, from, next) {
        const isKojin = myPageStore.personal.userKb === userType.Kojin;
        const status = isKojin ? taikyoStore.taikyoEntity.status : taikyoStore.selectedRooms[0].taikyoStatus;
        if (isNullOrUndefined(status) || status !== NyukyoStatus.Cleared) {
            if (isKojin) {
                await taikyoStore.load();
            }
            else {
                await taikyoStore.loadTaikyoNotification(taikyoStore.selectedRooms);
            }
        }
        if (myPageStore.isMultipleKeiyaku) {
            const fromScreen = from.name;
            const relatedScreens = isKojin ? ["taikyo-room-list"] : ["taikyo-applied-list"];
            if (relatedScreens.includes(fromScreen) && status === NyukyoStatus.Cleared) {
                next();
                return;
            }
        }
        else if (status === NyukyoStatus.Cleared) {
            next();
            return;
        }
        next({ name: "taikyo" });
    },
    setup() {
        const blob = ref(null);
        const fileName = ref("");
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        const router = useRouter();
        // 画面名取得
        const pageName = commonStore.pageName(PageID.kaiyakuSeisan);
        //ファイル関連
        const findFilesInfoCommand = new FindFilesInfoCommand();
        const getFilesCommand = new GetFilesCommand();
        const zipFile = ref(null);
        const fileList = ref([]);
        const isKojin = myPageStore.personal.userKb === userType.Kojin;
        const isFromBulkRoom = history.state.isFromBulkRoom;
        const initView = async () => {
            try {
                Loading.show({ message: commonStore.messages.PI0015 });
                /// 解約精算ファイルを取得する
                await fetchFiles();
            }
            catch (ex) {
                log.error("setup", ex);
                if (ex.status === 404) {
                    await MsgBox.error(commonStore.messages.PE0015);
                    router.back();
                }
                else {
                    MsgBox.error(ex.message);
                }
            }
        };
        const fetchFiles = async () => {
            try {
                Loading.show();
                // ファイル情報取得パラメータ設定
                const orgNyukyokeiyakuNo = isKojin ? myPageStore.selectedNyukyokeiyaku.orgNyukyokeiyakuNo : taikyoStore.selectedRooms[0].orgNyukyokeiyakuNo;
                findFilesInfoCommand.OrgNyukyokeiyakuNo = orgNyukyokeiyakuNo;
                findFilesInfoCommand.fileList = [new FindFileItemCommand(FileFetchKb.Reganam, FileCode.KaiyakuSeisanFile)];
                // ファイル情報取得
                const result = await api.common.findFilesInfo(findFilesInfoCommand);
                // ファイル取得
                const target = result.fileList.find(x => x.fileCode === FileCode.KaiyakuSeisanFile);
                // ファイル未存在
                if (!target?.fileExists) {
                    await MsgBox.error(commonStore.messages.PE0015);
                    router.back();
                    return;
                }
                // ファイル取得パラメータ設定
                getFilesCommand.OrgNyukyokeiyakuNo = orgNyukyokeiyakuNo;
                getFilesCommand.fileList = [
                    {
                        fileNo: target.fileNo,
                        fileFetchKb: FileFetchKb.Reganam,
                        fileCode: target.fileCode,
                        fileExists: target.fileExists
                    }
                ];
                // ファイル取得
                const res = await api.common.getFiles(getFilesCommand);
                zipFile.value = res;
                // Zip内のファイル取得
                fileList.value = await FileHelper.getFilesFromZip(zipFile.value, result.fileList);
                // 先頭ファイルのBlobとファイル名を設定
                if (fileList.value.length > 0) {
                    blob.value = fileList.value[0].blob ?? null;
                    fileName.value = fileList.value[0].fileName ?? null;
                }
                else {
                    blob.value = null;
                }
            }
            catch (ex) {
                MsgBox.error(ex.message);
            }
            finally {
                Loading.hide();
            }
        };
        const downloadFileByCode = async () => {
            const target = fileList.value.find(f => f.fileCode === FileCode.KaiyakuSeisanFile);
            if (!target || !target.fileNo) {
                return;
            }
            const fileData = await FileHelper.getFileFromZip(zipFile.value, target.fileNo);
            if (!fileData) {
                return;
            }
            FileHelper.downloadBlob(fileData.blob, fileData.fileName);
        };
        onMounted(async () => {
            await initView();
        });
        return {
            isFromBulkRoom,
            blob,
            fileName,
            isMultipleKeiyaku,
            fileList,
            isKojin,
            pageName,
            PageID,
            downloadFileByCode
        };
    }
});
